import { jsx as r, jsxs as i } from "react/jsx-runtime";
import f from "classnames";
import m from "../../utils/colors.js";
import { f as d } from "../../styled-qu50FBLM.mjs";
import { Svg as C, GElement as t, Path as n } from "./Elements.js";
const M = ({
  className: e = "",
  fill: l = m.orange,
  viewBox: a = "0 0 29 50",
  $cssHelper: s = d,
  focusable: o
}) => /* @__PURE__ */ r(
  C,
  {
    className: f({ [e]: !!e }),
    viewBox: a,
    $cssHelper: s,
    focusable: !!o,
    "aria-hidden": !o,
    children: /* @__PURE__ */ r(t, { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ r(t, { transform: "translate(-26.000000, -968.000000)", fill: l, children: /* @__PURE__ */ r(t, { transform: "translate(26.000000, 968.000000)", children: /* @__PURE__ */ i(t, { transform: "translate(-0.000000, 0.000000)", children: [
      /* @__PURE__ */ r(
        n,
        {
          d: "M-3.36029103,36.5266393 L34.306561,36.5266393 L34.306561,13.1789382 L-3.36029103,13.1789382 L-3.36029103,36.5266393 Z M-6.82971973,27.0125878 C-7.93313591,27.0125878 -8.82866208,26.1109485 -8.82866208,25 C-8.82866208,23.8890515 -7.93313591,22.9874122 -6.82971973,22.9874122 C-5.72630354,22.9874122 -4.83077737,23.8890515 -4.83077737,25 C-4.83077737,26.1109485 -5.72630354,27.0125878 -6.82971973,27.0125878 L-6.82971973,27.0125878 Z M-6.82971973,10.9118852 C-9.03855103,10.9118852 -10.8276044,12.7131513 -10.8276044,14.9370609 L-10.8276044,35.0629391 C-10.8276044,37.2868487 -9.03855103,39.0881148 -6.82971973,39.0881148 L35.1480698,39.0881148 C37.3569011,39.0881148 39.1459545,37.2868487 39.1459545,35.0629391 L39.1459545,14.9370609 C39.1459545,12.7151639 37.3569011,10.9118852 35.1480698,10.9118852 L-6.82971973,10.9118852 Z",
          transform: "translate(14.159175, 25.000000) rotate(-90.000000) translate(-14.159175, -25.000000) "
        }
      ),
      /* @__PURE__ */ r(
        n,
        {
          d: "M14.0625,29.1852679 C17.0904738,29.1852679 23.1350806,30.7431176 23.1350806,33.8355655 L23.1350806,33.8355655 L23.1350806,36.1607143 L4.98991935,36.1607143 L4.98991935,33.8355655 C4.98991935,30.7431176 11.0345262,29.1852679 14.0625,29.1852679 Z M14.0625,17.5595238 C16.567824,17.5595238 18.5987903,19.641533 18.5987903,22.2098214 C18.5987903,24.7781099 16.567824,26.860119 14.0625,26.860119 C11.557176,26.860119 9.52620968,24.7781099 9.52620968,22.2098214 C9.52620968,19.641533 11.557176,17.5595238 14.0625,17.5595238 Z",
          fillRule: "nonzero"
        }
      )
    ] }) }) }) })
  }
);
export {
  M as default
};
